import React, { useContext } from 'react';
import { useParams } from 'react-router';

import styled from '@emotion/styled';

import useGetDriverLookup from '../../../../hooks/dashboard/driver-lookup/useGetDriverLookup';
import useHireDispatcher from '../../../../hooks/dashboard/driver-lookup/useHireDispatcher';
import { useAppSelector } from '../../../../redux/store';
import { DRIVER_LOOKUP_INFO } from '../../../../routes/routeConstants';
import { FormSubmitButton } from '../../../Button/FormSubmitButton';
import { TranslatingContainerContext } from '../../../TranslatingContainer/TranslatingContainerProvider';
import { ModalContext } from '../../ModalContext';

interface SubmitCreateDispatcherProps {
  dispatcherData: any;
}

const SubmitCreateDispatcher: React.FC<SubmitCreateDispatcherProps> = ({
  dispatcherData,
}) => {
  const modalContext = useContext(ModalContext);
  const { getDriverLookup } = useGetDriverLookup();
  const { hireDispatcher, loading } = useHireDispatcher();
  const { setSliderIndexPos, resetSliderIndex } = useContext(
    TranslatingContainerContext,
  )!;
  const { hireDispatcherData } = useAppSelector(
    (state) => state.hireDispatcher,
  );

  const { ninNumber } = useParams();

  const onSubmit = () => {
    hireDispatcher(hireDispatcherData, () => {
      getDriverLookup(ninNumber, DRIVER_LOOKUP_INFO, () => {
        modalContext?.setShowModal(!modalContext?.showModal);
        resetSliderIndex();
      });
      modalContext?.setShowSuccessComponent(!modalContext.showModal);
    });
  };

  const handleBackToPrevious = () => {
    setSliderIndexPos(-1);
  };

  return (
    <Flex>
      <Description>
        {dispatcherData?.firstName} {dispatcherData?.lastName} is currently an
        employee of <span>{dispatcherData?.currentCompanyName}</span>?
      </Description>

      <ButtonArea>
        <FormSubmitButton
          className='clear fill text-red'
          onClick={handleBackToPrevious}
          btnType='button'
        >
          Back
        </FormSubmitButton>
        <FormSubmitButton
          loading={loading}
          btnType='button'
          onClick={onSubmit}
          className='fill'
        >
          Proceed
        </FormSubmitButton>
      </ButtonArea>
    </Flex>
  );
};

export default SubmitCreateDispatcher;

const ButtonArea = styled.div`
  display: flex;
  width: 100%;
  gap: 16px;
`;

const Flex = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

const Description = styled.div`
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.palette.grayTextColor};

  & > span {
    font-weight: 600;
  }
`;
